<template>
  <div>
    <div
      :class="{
                menu_box: true,
                'serach-bar': !mapBoxShow,
                'fullserach-bar': mapBoxShow,
            }"
    >
      <div class="left">
        <el-form @submit.native.prevent :inline="true" v-if="!searchDefault">
          <el-form-item>
            <el-input
              clearable
              v-model="searchForm.searchName"
              @clear="clear"
              @keyup.enter.native="onSearch"
              placeholder="请输入关键词"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch" class="search-btn">搜索</el-button>
          </el-form-item>
        </el-form>
        <slot v-else name="left-form"></slot>
      </div>
      <div class="right">
        <slot name="right-btns"></slot>
      </div>
    </div>
    <div class="serchBox">
      <slot name="bottom-btns" v-if="mapListShow"></slot>
      <slot name="mapBtn-btns" v-if="!mapListShow"></slot>
      <slot name="submit-btns"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      searchForm: {
        searchName: ""
      }
    };
  },
  props: {
    searchDefault: Boolean,
    mapBoxShow: {
      type: Boolean,
      default: false
    },
    mapListShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onSearch() {
      this.$emit("onSearch", this.searchForm);
    },
    clear() {
      this.$emit("onSearch", this.searchForm);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff !important;
  border: none;
  color: #e40e1b !important;
  box-shadow: none;
  border-left: 1px solid #ccc;
}
/deep/.el-radio-button__inner {
  border: none;
  border-left: 1px solid #ccc;
}
/deep/ .el-radio-button:first-child .el-radio-button__inner {
  border: none !important;
}
/deep/ .el-radio-button__inner:hover {
  color: #e40e1b !important;
}
/deep/ .el-radio-button__inner {
  padding: 5px 20px;
}

.serach-bar {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  height: 40px;
  background: #fff;
  padding: 0 20px;
  box-sizing: border-box;
  border: 1px solid #e4e7ed;
  border-bottom: none;
  display: flex;
  .left {
    flex: 1;
    overflow: hidden;
  }
}
.fullserach-bar {
  margin: 0 auto;
  position: relative;
  border: 1px solid #e4e7ed;
  height: 60px;
  background: #fff;
  padding: 10 20px;
  box-sizing: border-box;
  display: flex;
  .left {
    flex: 1;
    overflow: hidden;
  }
}
.serchBox {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  // position: relative;
  // height: 60px;
  background: #fff;
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  border-top: 1px solid #e4e7ed;
}
</style>
<style>
.serach-bar .el-form-item {
  margin-bottom: 0px;
}
.serach-bar .search-btn {
  background-color: #b79255;
  border-color: #b79255;
}
</style>
